export default "__VITE_ASSET__BttWNwQ___"